window.Slideshow = class {
  constructor(container) {
    this.container = container;
    this.body = document.querySelector("body");
  }
  
  createSlideshow(images, index) {
    this.images = images;
    this.currentIndex = index;
    let imageContainer = document.getElementById('slideshow-images');
    if(!imageContainer){
      imageContainer = document.createElement('div');
      imageContainer.id="slideshow-images";
    } else {
      imageContainer.innerHTML = '';
    }
    for (let i = 0; i < this.images.length; i++) {
      const image = document.createElement('img');
      image.src = this.images[i].src;
      image.alt = this.images[i].alt;
      if(i === this.currentIndex){
        image.classList.add('visible');
      }
      image.addEventListener('click', (event) => {
        this.indexChanged(1, event);
      })
      imageContainer.appendChild(image);
    }
    // append containers to main container
    this.body.style.overflowY = 'hidden';
    this.container.appendChild(imageContainer);
  }

  indexChanged(increment, evt){
    evt.stopPropagation();
    this.currentIndex+= increment;
    if(this.currentIndex < 0 ){
      this.currentIndex = this.images.length - 1;
    }
    if(this.currentIndex > this.images.length - 1){
      this.currentIndex = 0;
    }
    this.transitionToIndex(this.currentIndex);
  }

  closeSlideshow(){
    this.container.classList.remove("show");
    this.body.style.overflowY = 'auto';
  }
  
  transitionToIndex(index) {
    const images = document.querySelectorAll("#slideshow-images img");
    images.forEach(img => {
      img.classList.remove('visible')
    });
    images[index].classList.add('visible');
  }
}

window.openSlideshow = (gallery, selectedFoto, encoded = false) => {
  const galleryJSON = !encoded ? JSON.parse(gallery) : JSON.parse(decodeURIComponent(gallery));
  let index = selectedFoto;
  const images = galleryJSON.map(img => ({alt: img.title, src: img.fullUrl}))
  if(selectedFoto){
    console.log("images", images);
    console.log("selectedFoto", selectedFoto);
    console.log("index", images.findIndex(img => img.src === selectedFoto));
    index = images.findIndex(img => img.src === selectedFoto); 
  }
  slider.createSlideshow(images, index);
  container.classList.add("show");
}